import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Card, Loader } from '../../components';
import Header from './Header';
import { Container } from './common';
import Maps from '../../compositions/Maps';
import cardTypes from '~/helpers/cardTypes';
import Icon from '~/elements/Icon';
import { Button } from '~/elements';
import { openModal } from '~/store/modules/modal/actions';
import ProvisionalTransactions from '~/compositions/ProvisionalTransactions';
import devices from '~/styles/devices';
import { logoutUser } from '~/store/modules/user/actions';
import { cards } from '~/helpers/api';
import { setProvisionalCard } from '~/store/modules/home/actions';
import useMapsScript from '~/hooks/useMapsScript';
import axios from '~/config/axios';
import getCompanyFirstNameByIssuer from '~/helpers/getCompanyFirstNameByIssuer';

const Body = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: 34px;
  color: ${({ theme }) => theme.colors.gray400};
  margin-top: -177px;
  padding-top: 170px;
  min-height: ${({ minHeight }) => minHeight}px;

  @media (min-width: ${({ theme }) => theme.devices.tablet}) {
    padding-top: 157px;
    margin-top: -152px;
  }
`;
const CardDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.devices.tablet}) {
    flex-direction: row;
  }
`;
const Actions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 333px !important;
  margin-top: 30px;
  padding: 0 15px;

  .MuiButtonBase-root {
    padding: 12px 28px !important;
  }

  @media (min-width: ${({ theme }) => theme.devices.tablet}) {
    margin-top: 0;
    padding: 0;
  }
`;
const Title = styled.h2`
  display: none;
  font-weight: bold;
  font-size: 26px;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 49px;
  span {
    text-transform: capitalize;
  }

  @media (min-width: ${devices.tablet}) {
    display: block;
  }
`;
const AnotherSearch = styled(Button)`
  margin-top: 13px !important;
`;

const ProvisionalCard = () => {
  const [showMaps, setShowMaps] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [documentHeight, setDocumentHeight] = useState(window.innerHeight);
  const body = useRef();
  const card = useSelector(state => state.home.cards.provisional);
  const issuerName = useSelector(state => state?.issuer?.name);

  const dispatch = useDispatch();
  const history = useHistory();
  useMapsScript();

  if (!card?.codigoProduto) {
    history.push('/home');
  }

  useEffect(() => {
    if (card?.codigoProduto) {
      window.addEventListener('resize', () => {
        setDocumentHeight(window.innerHeight);
      });
    }
    // eslint-disable-next-line
  }, [card]);

  function logout() {
    axios.defaults.headers.common.Authorization = '';
    sessionStorage.removeItem('token');
    dispatch(logoutUser());
    history.push('/login');
  }

  async function getCards() {
    let response = '';
    try {
      setIsLoading(true);
      response = await cards.getCards();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setIsLoading(false);
    }

    return response;
  }

  async function handleOnClick() {
    const response = await getCards();
    if (response?.length > 0) {
      history.push('/home');
    } else {
      logout();
    }
    dispatch(setProvisionalCard({}));
  }

  const companyFirstName = getCompanyFirstNameByIssuer(issuerName);

  return (
    <Loader isLoading={isLoading}>
      <Container>
        <Header onClick={handleOnClick} />
      </Container>
      <CardDetailsContainer>
        <Card type={card.codigoProduto} data={card} />
        <Actions>
          <Title>
            <span>
              {companyFirstName} {cardTypes[card.codigoProduto]}
            </span>
          </Title>
          <Button
            variant="outlined"
            color={card.codigoProduto}
            label="Onde usar meu cartão"
            startIcon={<Icon icon={['far', 'map-marker']} />}
            onClick={() => setShowMaps(true)}
            fullWidth
          />
          <AnotherSearch
            variant="outlined"
            color={card.codigoProduto}
            label="Fazer nova consulta"
            onClick={() => dispatch(openModal('quick_search'))}
            fullWidth
          />
        </Actions>
      </CardDetailsContainer>
      <Body
        minHeight={documentHeight - body?.current?.getBoundingClientRect().top}
        ref={body}
      >
        <Container>
          <ProvisionalTransactions card={card} />
        </Container>
      </Body>
      <Maps show={showMaps} handleClose={() => setShowMaps(false)} />
    </Loader>
  );
};

export default ProvisionalCard;
